export const PAGE_SEGMENT_MARK_PREFIX_START = 'segment-start';
export const PAGE_SEGMENT_MARK_PREFIX_END = 'segment-end';
